import { render, staticRenderFns } from "./DocumentFilingDateWidget.vue?vue&type=template&id=644585d4&"
import script from "./DocumentFilingDateWidget.vue?vue&type=script&lang=js&"
export * from "./DocumentFilingDateWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports